package ru.dinarastepina.fabvocab.contracts

import kotlinx.serialization.Serializable

@Serializable
data class SaveWordResponse(
    val id: String,
    val word: WordEntryDto,
)

@Serializable
data class ApiErrorDto(
    val message: String,
)
